import { motion } from "framer-motion";
import {
  card,
  cardTitle,
  microLabel,
  bodySecondary,
  dividerInner,
  motionStaggerChild,
} from "../../../lib/design-system";
import { cn } from "../../../lib/utils";

const CourseInfo = ({ course }) => {
  return (
    <div className={cn(card, "overflow-hidden")}>
      {/* Header */}
      <div className={cn("p-6 border-b", dividerInner)}>
        <h3 className={cardTitle}>Course Details</h3>
      </div>

      <div className="p-6 space-y-5">
        {/* About */}
        {course.aboutCourse && (
          <motion.div {...motionStaggerChild(0)}>
            <p className={cn(bodySecondary, "leading-relaxed")}>
              {course.aboutCourse}
            </p>
          </motion.div>
        )}

        {/* Semester */}
        {course.semester && (
          <motion.div
            {...motionStaggerChild(1)}
            className="bg-gray-50 dark:bg-gray-900 p-3 rounded-sm"
          >
            <p className={cn(microLabel, "mb-1")}>Semester</p>
            <p className={bodySecondary}>
              {course.semester.name} &middot;{" "}
              {new Date(course.semester.startDate).toLocaleDateString()} –{" "}
              {new Date(course.semester.endDate).toLocaleDateString()}
            </p>
          </motion.div>
        )}

        {/* Credit Points */}
        {course.creditPoints && (
          <motion.div
            {...motionStaggerChild(2)}
            className="bg-gray-50 dark:bg-gray-900 p-3 rounded-sm"
          >
            <p className={cn(microLabel, "mb-2")}>Credits</p>
            <div className="flex flex-wrap gap-3">
              {[
                { label: "Lecture", value: course.creditPoints.lecture },
                { label: "Tutorial", value: course.creditPoints.tutorial },
                { label: "Practical", value: course.creditPoints.practical },
                { label: "Project", value: course.creditPoints.project },
              ].map((item) => (
                <span key={item.label} className={bodySecondary}>
                  <span className="font-semibold text-gray-700 dark:text-gray-300">
                    {item.label}
                  </span>{" "}
                  {item.value}
                </span>
              ))}
            </div>
          </motion.div>
        )}

        {/* Learning Outcomes */}
        {course.learningOutcomes?.length > 0 && (
          <motion.div {...motionStaggerChild(3)}>
            <h4 className={cn(cardTitle, "mb-3")}>Learning Outcomes</h4>
            <ol className="space-y-2">
              {course.learningOutcomes.map((outcome, index) => (
                <li key={index} className="flex gap-3">
                  <span className="text-accent1 font-bold text-sm min-w-[1.25rem]">
                    {index + 1}.
                  </span>
                  <span className={cn(bodySecondary, "leading-relaxed")}>
                    {outcome}
                  </span>
                </li>
              ))}
            </ol>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default CourseInfo;
